import { z } from "zod";

import { ApiService } from "./ApiService";

export const GrantedPermissions = z.record(z.string(), z.string().array());
export type GrantedPermissions = z.infer<typeof GrantedPermissions>;

export const Permissions = z.record(z.string(), z.record(z.string(), z.boolean()));
export type Permissions = z.infer<typeof Permissions>;

// section names are translated with "sections.{section}"
// resource names are translated with "permissions.{resource}"
// actions are translated with "permissions.actions.{resource}:{action}" or with "permissions.actions.{action}"
export const PERMISSION_SECTIONS = {
    products: {
        product: ["read", "edit", "delete"],
        operational_cost: ["read", "edit", "delete"],
        ingredient: ["read", "edit", "delete"],
        category: ["read", "edit", "delete"],
        package: ["read", "edit", "delete"],
        ean: ["read"],
        prototype: ["read", "edit", "delete"],
    },
    production: {
        order: ["read", "edit", "delete"],
        calendar: ["edit"],
        production_plan: ["read", "edit", "delete"],
        protocol: ["read", "edit", "delete"],
        stock_item: ["read"],
        mixing: ["read"],
        mix_completion: ["read"],
        pick_container: ["read", "edit", "delete"],
        pick_order: ["read"],
        tablet: ["read", "edit", "delete"],
    },
    stats: {
        stats: [
            "day2day",
            "aggregated_orders",
            "product_sales",
            "sent_packages",
            "mixing_mixes",
            "mix_completion",
            "logging",
            "waiting_orders",
            "rewards",
            "ordered_mixes",
            "production_analysis",
            "picking_items",
        ],
    },
    expedition: {
        label: ["generate", "print_qr_label"],
        expedition_package: ["read"],
        expedition_user_action: ["form"],
        expedition_user: ["read", "edit", "delete"],
        expedition_label_type: ["read"],
        package_code: ["read"],
    },
    settings: {
        role: ["read", "edit", "delete"],
        admin_user: ["read", "edit", "delete"],
        employee: ["read", "edit", "delete"],
        payment: ["read", "edit", "delete"],
        transport: ["read", "edit", "delete"],
    },
};

class PermissionsService extends ApiService {
    async getPermissions(): Promise<GrantedPermissions> {
        const response = await this.get("my-permissions");
        return GrantedPermissions.parse(response);
    }
}

export default new PermissionsService();
